import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { LogIn } from "lucide-react";

import "./Header.css";
import logo from "../../images/logo.png";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`Header-wrapper ${
        scrolled ? "Header-scrolled" : ""
      }`}
    >
      <div className="Header-container">

        {/* LOGO */}
        <NavLink
          to="/"
          className="Header-logo"
        >
          <img
            src={logo}
            alt="Bairagi Consultants"
          />

          <span>Bairagi Consultants</span>
        </NavLink>

        {/* NAVIGATION */}
        <nav
          className={`Header-links ${
            mobileMenu ? "Header-mobile-open" : ""
          }`}
        >

          {/* HOME */}
          <NavLink
            to="/"
            onClick={() => setMobileMenu(false)}
          >
            Home
          </NavLink>

          {/* SOLUTIONS */}
          <div className="Header-dropdown">

            <button
              type="button"
              className="Header-dropdown-btn"
            >
              Solutions

              <span className="Header-dropdown-arrow">
                ▼
              </span>
            </button>

            <div className="Header-dropdown-menu">

              <NavLink
                to="/ecommerce-development"
                onClick={() => setMobileMenu(false)}
              >
                Ecommerce Development
              </NavLink>

              <NavLink
                to="/mobile-app-development"
                onClick={() => setMobileMenu(false)}
              >
                Mobile App Development
              </NavLink>

              <NavLink
                to="/crm-software-development"
                onClick={() => setMobileMenu(false)}
              >
                CRM Software
              </NavLink>

              <NavLink
                to="/ai-software-solutions"
                onClick={() => setMobileMenu(false)}
              >
                AI Solutions
              </NavLink>

              <NavLink
                to="/custom-dashboard-development"
                onClick={() => setMobileMenu(false)}
              >
                Dashboard Development
              </NavLink>

            </div>

          </div>

          {/* CASE STUDIES */}
          <NavLink
            to="/case-studies"
            onClick={() => setMobileMenu(false)}
          >
            Case Studies
          </NavLink>

          {/* ABOUT */}
          <NavLink
            to="/about"
            onClick={() => setMobileMenu(false)}
          >
            About
          </NavLink>

          {/* BLOG */}
          <NavLink
            to="/blog"
            onClick={() => setMobileMenu(false)}
          >
            Blog
          </NavLink>

          {/* CONTACT */}
          <NavLink
            to="/contact"
            onClick={() => setMobileMenu(false)}
          >
            Contact
          </NavLink>

        </nav>

        {/* ACTIONS */}
        <div className="Header-actions">

          {/* LOGIN */}
          <NavLink
            to="/admin/login"
            className="Header-login"
          >
            <LogIn size={17} />
            <span>Login</span>
          </NavLink>

          {/* CONSULTATION CTA */}
          <NavLink
            to="/contact"
            className="Header-cta"
          >
            Book Consultation
          </NavLink>

          {/* MOBILE MENU */}
          <button
            type="button"
            className="Header-menu-button"
            onClick={() => setMobileMenu(!mobileMenu)}
            aria-label="Toggle navigation"
          >
            {mobileMenu ? "✕" : "☰"}
          </button>

        </div>

      </div>

    </header>
  );
};

export default Header;